import React from 'react';

import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface BreadcrumbProps {
  children: React.ReactNode;
  className?: string;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  children,
  className = '',
}) => {
  return (
    <nav className={`flex items-center gap-1.5 text-xs ${className}`}>
      {children}
    </nav>
  );
};

interface BreadcrumbItemProps {
  children: React.ReactNode;
  to?: string;
  href?: string;
  current?: boolean;
  onClick?: () => void;
}

export const BreadcrumbItem: React.FC<BreadcrumbItemProps> = ({
  children,
  to,
  href,
  current = false,
  onClick,
}) => {
  const isInteractive = Boolean(to || href || onClick);
  const linkClass =
    'text-neutral-600 dark:text-neutral-400 hover:text-brand-600 dark:hover:text-brand-400 transition-colors';
  const currentClass = 'text-neutral-900 dark:text-white';

  if (current) {
    if (to) {
      return (
        <Link to={to} onClick={onClick} className={currentClass}>
          {children}
        </Link>
      );
    }
    if (href) {
      return (
        <a href={href} onClick={onClick} className={currentClass}>
          {children}
        </a>
      );
    }
    if (onClick) {
      return (
        <button type="button" onClick={onClick} className={currentClass}>
          {children}
        </button>
      );
    }
    return <span className={currentClass}>{children}</span>;
  }

  return (
    <>
      {to ? (
        <Link to={to} onClick={onClick} className={linkClass}>
          {children}
        </Link>
      ) : href ? (
        <a href={href} onClick={onClick} className={linkClass}>
          {children}
        </a>
      ) : onClick ? (
        <button type="button" onClick={onClick} className={linkClass}>
          {children}
        </button>
      ) : (
        <span className="text-neutral-600 dark:text-neutral-400">{children}</span>
      )}
      <ChevronRight className="w-4 h-4 text-neutral-400 dark:text-neutral-600" />
    </>
  );
};
